import React from "react";
import { Check, Link2, Trash2, X } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { STATUS } from "@/pages/admin/customers/customerConstants";

export const CustomersTable = ({ shops, staff, onOpenDetail, onUpdateStatus, onLinkLead, onDelete }) => (
  <Card className="overflow-hidden">
    <div className="overflow-x-auto">
      <Table data-testid="admin-shop-approvals-table">
        <TableHeader><TableRow className="bg-[#F4EBDD]">
          <TableHead>Shop</TableHead><TableHead>Phone</TableHead><TableHead>City</TableHead><TableHead>Tier</TableHead><TableHead>Orders</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Actions</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {shops.map((s) => (
            <TableRow key={s.id} className="hover:bg-[#F7F0E6] cursor-pointer" onClick={() => onOpenDetail(s)}>
              <TableCell>
                <div className="font-medium">{s.shop_name}</div>
                <div className="text-xs text-muted-foreground">{s.contact_person}</div>
                {s.matched_lead_id && (
                  <Button data-testid="link-lead-button" size="sm" variant="outline" className="mt-1 h-6 gap-1 text-xs px-2" onClick={(e) => { e.stopPropagation(); onLinkLead(s); }}>
                    <Link2 className="h-3 w-3" /> Matches lead “{s.matched_lead_company}” — Link
                  </Button>
                )}
              </TableCell>
              <TableCell className="font-mono text-sm">{s.phone}</TableCell>
              <TableCell>{s.city || "-"}</TableCell>
              <TableCell>{s.discount_pct > 0 ? <Badge className="bg-[#FFF7E6] text-[#8E6F33] border border-[#E7D0A8]">{s.tier || "Custom"} · {s.discount_pct}%</Badge> : <span className="text-muted-foreground text-sm">Standard</span>}</TableCell>
              <TableCell>{s.order_count}</TableCell>
              <TableCell><Badge className={STATUS[s.status]}>{s.status}</Badge></TableCell>
              <TableCell className="text-right" onClick={(e) => e.stopPropagation()}>
                {s.status !== "approved" && <Button data-testid="admin-approve-button" size="sm" variant="secondary" className="gap-1 mr-1" onClick={() => onUpdateStatus(s.id, "approved")}><Check className="h-3.5 w-3.5" /> Approve</Button>}
                {s.status !== "rejected" && <Button data-testid="admin-reject-button" size="sm" variant="ghost" className="gap-1" onClick={() => onUpdateStatus(s.id, "rejected")}><X className="h-3.5 w-3.5" /> Reject</Button>}
                {staff?.is_manager && (
                  <Button data-testid="customer-delete-button" size="sm" variant="ghost" className="gap-1 text-destructive hover:text-destructive" onClick={() => onDelete(s)}><Trash2 className="h-3.5 w-3.5" /></Button>
                )}
              </TableCell>
            </TableRow>
          ))}
          {shops.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-10 text-muted-foreground">No shops in this view.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  </Card>
);
